import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=20538510&"
import script from "./ProductInformation.vue?vue&type=script&lang=ts&"
export * from "./ProductInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports